<div class="flex">
  <div class="col-fixed px-0" [style.width.px]="50" *ngIf="!readonly">
    <button pButton icon="fas fa-trash" type="button" class="p-button-danger" (click)="remove.emit()">
    </button>
  </div>

  <div class="col px-0 md:pt-0 inline-flex flex-wrap align-items-center">
    <label class="col-12 px-0 hide-from-small">{{screen.code}}: {{diagnostic.cieHelp?.id}}</label>
    <span class="col-fixed px-2 hide-on-medium" [style.width.px]="70"
      *ngIf="diagnostic.cieHelp?.id">{{diagnostic.cieHelp?.id}}</span>
    <div class="col pl-0">
      <p-autoComplete name="diagnostic_description_{{idx}}_{{turn}}" [(ngModel)]="diagnostic.cieHelp" [minLength]="3"
        dataKey="id" field="displayName" [suggestions]="suggestions" (completeMethod)="getSuggestions($event.query)"
        (onSelect)="fillWithSuggestion($event)" (onKeyUp)="onKeyUp(false)" inputStyleClass="uppercase ellipsis"
        [required]="!readonly && idx === 0" [readonly]="readonly" validation *ngIf="!readonly">
        <ng-template let-cie pTemplate="item">
          <b>{{cie.id}}</b> - {{cie.displayName}}
        </ng-template>
      </p-autoComplete>

      <span *ngIf="readonly">
        {{diagnostic.cieHelp?.displayName}}
      </span>
    </div>
    <div class="col-fixed px-0 py-0 inline-flex justify-content-center" [style.width.px]="20" *ngIf="description">
      <i class="far fa-question-circle" [pTooltip]="description"></i>
    </div>

    <div class="col-12 px-0 py-0 hide-from-small"></div>

    <div class="col-fixed px-0 inline-flex flex-column align-items-center" [style.width.px]="60">
      <label class="hide-from-small">{{screen.pre}}:</label>
      <span class="inline-flex justify-content-center">
        <p-radioButton name="radio-diagnostic_{{idx}}_{{turn}}" [value]="true" [(ngModel)]="diagnostic.isFinal"
          (ngModelChange)="handleChange()" [disabled]="readonly">
        </p-radioButton>
      </span>
    </div>

    <div class="col-fixed px-0 inline-flex flex-column align-items-center" [style.width.px]="60">
      <label class="hide-from-small">{{screen.def}}:</label>
      <span class="inline-flex justify-content-center">
        <p-radioButton name="radio-diagnostic_{{idx}}_{{turn}}" [value]="false" [(ngModel)]="diagnostic.isFinal"
          (ngModelChange)="handleChange()" [disabled]="readonly"></p-radioButton>
      </span>
    </div>
  </div>
</div>